import { Route, Switch } from 'react-router-dom'
import { asyncComponent } from '../../components/async-component'

const XpnPrintViewPage = asyncComponent(
  () => import(/* webpackChunkName: "XpnPrintViewPage" */ './print-view/xpn-print-view-page'),
  'XpnFullReportPage'
)
const EqxPrintViewPage = asyncComponent(
  () => import(/* webpackChunkName: "EqxPrintViewPage" */ './print-view/eqx-print-view-page'),
  'EqxFullReportPage'
)

const ReportsPage = asyncComponent(() => import(/* webpackChunkName: "ReportsPage" */ './page'), 'PremiumPage')
const ReportPage = asyncComponent(() => import(/* webpackChunkName: "ReportPage" */ './reports'), 'PremiumReportsPage')

export const Premium = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={ReportsPage} />
    <Route exact path={`${match.path}/print-view/xpn`} component={XpnPrintViewPage} />
    <Route exact path={`${match.path}/print-view/eqx`} component={EqxPrintViewPage} />
    <Route path={`${match.path}/:bureau`} component={ReportPage} />
  </Switch>
)
